/** @file labelComponents: 8-connected components of a 0/1 mask, labelled 1..count in scan order. */

/** Floods the component holding `seed` with `label`, an explicit stack (no recursion). */
function flood(mask: Uint8Array, labels: Int32Array, width: number, seed: number, label: number): void {
  const height = mask.length / width;
  const stack = [seed];
  labels[seed] = label;
  while (stack.length > 0) {
    const p = stack.pop() ?? 0;
    const x = p % width;
    const y = (p - x) / width;
    for (let k = 0; k < 9; k++) {
      const nx = x + (k % 3) - 1;
      const ny = y + Math.floor(k / 3) - 1;
      const q = ny * width + nx;
      if (nx < 0 || nx >= width || ny < 0 || ny >= height || mask[q] !== 1 || labels[q] !== 0) continue;
      labels[q] = label;
      stack.push(q);
    }
  }
}

/** Labels (`width * height`, 0 = background) and the component count; the first component met in scan order is 1. */
export function labelComponents(mask: Uint8Array, width: number): { labels: Int32Array; count: number } {
  const labels = new Int32Array(mask.length);
  let count = 0;
  for (let p = 0; p < mask.length; p++) {
    if (mask[p] !== 1 || labels[p] !== 0) continue;
    count += 1;
    flood(mask, labels, width, p, count);
  }
  return { labels, count };
}
